import React from "react";
import Translator, { __ } from "services/Translator";

// Cohesive, on-brand icon set (single flat style, rendered on a gold disc via
// CSS). Replaces the mismatched clip-art/stock PNGs so the "elite" pitch reads
// premium rather than cheap. Self-contained — no asset-file dependency.
function RankIcon({ name }) {
  const paths = {
    rebate: (
      <g>
        <circle cx="12" cy="12" r="8.5" fill="none" stroke="currentColor" strokeWidth="1.8" />
        <path
          d="M15.5 9.2a4.4 4.4 0 1 0 .6 4.9"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <path d="M15.9 6.4l.2 3.2-3.1-.5z" />
      </g>
    ),
    crown: (
      <g>
        <path d="M4 8.5l3.2 3L12 5l4.8 6.5L20 8.5l-1.4 9H5.4L4 8.5z" />
        <rect x="5.4" y="18" width="13.2" height="2.4" rx="1" />
        <circle cx="4" cy="8" r="1.6" />
        <circle cx="20" cy="8" r="1.6" />
        <circle cx="12" cy="4.4" r="1.6" />
      </g>
    ),
    ladder: (
      <g>
        <rect x="3.5" y="15" width="4.4" height="5.5" rx="1" />
        <rect x="9.8" y="10.5" width="4.4" height="10" rx="1" />
        <rect x="16.1" y="5.5" width="4.4" height="15" rx="1" />
      </g>
    ),
    gift: (
      <g>
        <rect x="4" y="10.5" width="16" height="9.5" rx="1.4" />
        <rect x="3" y="7.5" width="18" height="4" rx="1" />
        <rect x="11" y="7.5" width="2" height="12.5" />
        <path d="M12 7.5c-1-3-5-3-5-1 0 1.6 3 1 5 1zm0 0c1-3 5-3 5-1 0 1.6-3 1-5 1z" />
      </g>
    ),
  };
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
      {paths[name] || paths.crown}
    </svg>
  );
}

const RankSystem = (props) => {
  return (
    <div className="rank-system">
      <h2 className="vipHeading">
        {__("More play, more perks —")}{" "}
        <span>{__("the Clover Climber VIP Club")}</span>
      </h2>
      <div className="content">
        {props.isMobileDevice && (
          <div className="roulette">
            <img
              src={require("assets/play365/images/vip/stars.webp")}
              alt="Roulette"
            />
          </div>
        )}
        <div className="itemLists">
          <div className="benefit boost">
            <span className="benefit-ic" aria-hidden="true">
              <RankIcon name="rebate" />
            </span>
            <div className="benefitContent">
              <h3>{__("Boosted Rebates")}</h3>
              <i>{__("Coin Comebacks")}</i>
              <p>
                {__("Turn losses into chances! Get up to")}{" "}
                <b>{__("25% of your coins back")}</b>{" "}
                {__(
                  "as you climb the VIP ladder. The higher your rank, the greater the cashback. It’s not just a refund – it’s your second shot at glory"
                )}
              </p>
            </div>
          </div>
          <div className="benefit vip">
            <span className="benefit-ic" aria-hidden="true">
              <RankIcon name="crown" />
            </span>
            <div className="benefitContent">
              <h3>{__("VIP Circle")}</h3>
              <i>{__("Elite Player Zone")}</i>
              <p>
                {__(
                  "Step into the circle of champions. As a VIP, you’ll unlock"
                )}{" "}
                <b>{__("custom bonuses")}</b>,{" "}
                {__("early access to games, and")}{" "}
                <b>{__("premium treatment")}</b>{" "}
                {__(
                  "at every level. It’s more than a club—it’s your casino kingdom."
                )}
              </p>
            </div>
          </div>

          <div className="benefit tiers">
            <span className="benefit-ic" aria-hidden="true">
              <RankIcon name="ladder" />
            </span>
            <div className="benefitContent">
              <h3>{__("Tiers & Treats")}</h3>
              <i>{__("Tier Up, Win More")}</i>
              <p>
                {__(
                  "Every game brings you closer to epic rewards. The more you play, the more you earn. Reach new tiers and enjoy"
                )}{" "}
                <b>{__("exclusive prizes")}</b>,{" "}
                {__(
                  "surprise bonuses, and a VIP experience tailored to your playstyle."
                )}
              </p>
            </div>
          </div>
          <div className="benefit special">
            <span className="benefit-ic" aria-hidden="true">
              <RankIcon name="gift" />
            </span>
            <div className="benefitContent">
              <h3>{__("Special Offers")}</h3>
              <i>{__("Next-Level Perks")}</i>
              <p>
                {__("Climb the ranks and uncover")} <b>{__("one-of-a-kind")}</b>{" "}
                {__(
                  "rewards. From personalized gifts to exclusive promotions, each new level brings surprises that are truly worth the play. Welcome to VIP done right."
                )}
              </p>
            </div>
          </div>
        </div>

        {!props.isMobileDevice && (
          <div className="roulette">
            <img
              src={require("assets/play365/images/vip/stars.webp")}
              alt="Roulette"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default RankSystem;
